<template>
  <b-row v-if="totalItems > 0" class="mt-4">
    <b-col>
      <p class="mt-3 text-dark mb-0" style="font-weight: 500">
        Tổng số: {{ totalItems }}
      </p>
    </b-col>
    <b-col>
      <b-pagination
        v-if="numberOfPage >= 2"
        v-model="page"
        class="custom-pagination"
        :total-rows="totalItems"
        :per-page="perPage"
        @change="handlePageChange"
        align="right"
        first-class="page-item-first btn btn-icon btn-sm m-1"
        prev-class="page-item-prev btn btn-icon btn-sm m-1"
        next-class="page-item-next btn btn-icon btn-sm m-1"
        last-class="page-item-last btn btn-icon btn-sm m-1"
        page-class="btn btn-icon btn-sm border-0 m-1"
      >
        <template v-slot:first-text>
          <span><i class="ki ki-double-arrow-back icon-xs"></i></span>
        </template>
        <template v-slot:prev-text>
          <i class="ki ki-arrow-back icon-xs"></i>
        </template>
        <template v-slot:next-text>
          <i class="ki ki-arrow-next icon-xs"></i>
        </template>
        <template v-slot:last-text>
          <span class="text-info">
            <i class="ki ki-double-arrow-next icon-xs"></i>
          </span>
        </template>
      </b-pagination>
    </b-col>
  </b-row>
</template>

<script>
export default {
  name: 'OrderLogPagination',
  props: {
    currentPage: {
      type: Number,
      required: true,
    },
    totalItems: {
      type: Number,
      required: true,
    },
    perPage: {
      type: Number,
      default: 20,
    },
  },
  data() {
    return {
      page: this.currentPage,
    };
  },
  computed: {
    numberOfPage() {
      return Math.ceil(this.totalItems / this.perPage) || 1;
    },
  },
  watch: {
    currentPage(newVal) {
      this.page = newVal;
    },
  },
  methods: {
    handlePageChange(page) {
      this.$emit('page-change', page);
    },
  },
};
</script>
